import { Extension } from '@tiptap/core';

export const EmitUpdate = Extension.create({
  name: 'emitUpdate',

  addCommands() {
    return {
      // Do not use inside chain(): it would emit before the chained transaction is dispatched
      emitUpdate: () => ({ editor, dispatch }) => {
        if (dispatch) {
          editor.emit('update', { editor, transaction: editor.state.tr, appendedTransactions: [] });
        }
        return true;
      },
    };
  },
});
